export interface IPageHeader {
    isLocalizedKey: boolean;
    value: string;
}
